<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { getRegion } from '@/api/region/index'
import { getServerinfo } from '@/api/server/index'
import { getTaskType } from '@/api/tasktype/index'
export default {
  async created () {
    const resGetRegion = await getRegion()
    const resGetServerinfo = await getServerinfo()
    const resGetTaskType = await getTaskType()
    this.$store.commit('basicdata/setRegionList', resGetRegion.data)
    this.$store.commit('basicdata/setServerList', resGetServerinfo.data)
    this.$store.commit('basicdata/setTaskTypeList', resGetTaskType.data)
  }
}

</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>
